import { getUserConfiguration } from 'owa-session-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import SegmentationSettingsType from 'owa-service/lib/contract/SegmentationSettingsType';
import TenantThemeData from 'owa-service/lib/contract/TenantThemeData';

export function isUserPersonalizationAllowed(): boolean {
    const {
        SegmentationSettings: { Themes } = {} as SegmentationSettingsType,
        TenantThemeData: { UserPersonalizationAllowed } = {} as TenantThemeData,
    } = getUserConfiguration();
    return !!Themes && (isConsumer() || UserPersonalizationAllowed !== false);
}
